import React, { useEffect } from "react";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { stringToUrl, urlToString } from "../../events/utils/event";
import OAuth2IDResponse from "../OAuth2IDResponse/OAuth2IDResponse";
import {
  findGetParameter,
  utf8ToBase64
} from "../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../global/environmentVariables";
import uniqid from "uniqid";
import {
  getLocalStorage,
  setLocalStorage
} from "../../../components/layout/cookies/CookieFunctions";

export default function Login(props) {
  const id_token = findGetParameter("id_token");
  const access_token = findGetParameter("access_token");
  const refresh_token = findGetParameter("refresh_token");
  const exchange_token = findGetParameter("exchange_token");
  const code = findGetParameter("code");
  const post_login_uri = getLocalStorage("bcpRedirectUrl");

  const defaultUrl = `${window.location.origin}/login`;

  const redirectUrlParam = findGetParameter("redirect_url")
    ? urlToString(findGetParameter("redirect_url"))
    : null;

  if (redirectUrlParam) {
    setLocalStorage("bcpRedirectUrl", redirectUrlParam);
  }

  useEffect(() => window.scrollTo(0, 0), []);

  useEffect(() => {
    if (
      !id_token &&
      !access_token &&
      !refresh_token &&
      !exchange_token &&
      !code
    ) {
      const stateObj = {
        redirect_uri: defaultUrl,
        client_id: getEnvironmentVariable("AUTH_CLIENT_ID"),
        salt: uniqid()
      };

      const state = utf8ToBase64(JSON.stringify(stateObj));

      setLocalStorage(
        "bcpRedirectUrl",
        window.location.pathname === "/login"
          ? document.referrer
          : window.location.href
      );
      setLocalStorage("bcpState", state);

      const redirectUrl = `${getEnvironmentVariable(
        "AUTH_HOSTED_UI"
      )}login?client_id=${getEnvironmentVariable(
        "AUTH_CLIENT_ID"
      )}&response_type=code&scope=email+openid+profile&redirect_uri=${stringToUrl(
        defaultUrl
      )}&state=${state}`;

      window.location.assign(redirectUrl);
    }

    // eslint-disable-next-line
  }, []);

  if ((id_token && access_token && refresh_token) || exchange_token || code) {
    return (
      <OAuth2IDResponse redirectUrl={post_login_uri} defaultUrl={defaultUrl} />
    );
  }

  return <ModalLoadingFull />;
}
